import React from 'react'
import './page-title.css'

const PageTitle = ({pageTitle, articleTitle, children, ignoreForDoc, /*...*/}) => {

    let pTitle = '';

    if (articleTitle !== undefined) {
        pTitle = `${articleTitle} - ${children}`
    } else if (pageTitle !== undefined) {
        pTitle = `${pageTitle}`
    } else if (children !== undefined) {
        pTitle = `${children}`
    }

    if (!ignoreForDoc) {
        document.title = pTitle;
    }

    return children ? <div className="page-title">
                        <h1 className="text-uppercase">{children}</h1>
                      </div>
                    : null

};

export default PageTitle;


// WEBPACK FOOTER //
// ./src/components/common/page-title/index.jsx